import { useMemo } from "react";
import PropTypes from "prop-types";

const Key = ({
  className = "",
  style = "Lowercase",
  showKey,
  keyBorder,
  keyPadding,
  keyWidth,
  keyFlex,
  letter,
  letterTextTransform,
  showIcon,
  iconLeft,
}) => {
  const keyStyle = useMemo(() => {
    return {
      border: keyBorder,
      padding: keyPadding,
      width: keyWidth,
      flex: keyFlex,
    };
  }, [keyBorder, keyPadding, keyWidth, keyFlex]);

  const letterStyle = useMemo(() => {
    return {
      textTransform: letterTextTransform,
    };
  }, [letterTextTransform]);

  const iconStyle = useMemo(() => {
    return {
      left: iconLeft,
    };
  }, [iconLeft]);

  return (
    showKey && (
      <div
        className={`w-[31.5px] relative shadow-[0px_1px_0px_rgba(0,_0,_0,_0.3)] rounded-8xs bg-light-primary-key-background h-[42px] text-center text-6xl text-light-text1 font-text-regular-lowercase data-[style='Small']:bg-light-secondary-key-background [&_.letter]:data-[style='Small']:top-[calc(50%_-_10px)] [&_.letter]:data-[style='Small']:left-[31px] [&_.letter]:data-[style='Small']:text-base [&_.letter]:data-[style='Small']:font-text-small [&_.letter]:data-[style='Small']:[display:unset] [&_.letter]:data-[style='Small']:[align-items:unset] [&_.letter]:data-[style='Small']:[justify-content:unset] [&_.letter]:data-[style='Small']:tracking-[-0.4px] [&_.letter]:data-[style='Small']:leading-[21px] [&_.icon]:data-[style='Small']:hidden ${className}`}
        data-style={style}
        style={keyStyle}
      >
        <div
          className="letter absolute top-[calc(50%_-_22px)] left-[0px] flex items-center justify-center"
          style={letterStyle}
        >
          {letter}
        </div>
        {showIcon && (
          <img
            className="icon absolute top-[calc(50%_-_16px)] left-[calc(50%_-_15.75px)] w-8 h-8 overflow-hidden"
            alt=""
            src="/icon.svg"
            style={iconStyle}
          />
        )}
      </div>
    )
  );
};

Key.propTypes = {
  className: PropTypes.string,
  showKey: PropTypes.bool,
  letter: PropTypes.string,
  showIcon: PropTypes.bool,

  /** Variant props */
  style: PropTypes.string,

  /** Style props */
  keyBorder: PropTypes.string,
  keyPadding: PropTypes.string,
  keyWidth: PropTypes.string,
  keyFlex: PropTypes.string,
  letterTextTransform: PropTypes.string,
  iconLeft: PropTypes.string,
};

export default Key;
